module.exports = __webpack_public_path__ + "static/wood-style-1-e3577ddd019c610cedbeb38ebff4e2ef.png";